import { KeyLabelPair } from "@/config/types";
import { Radio, RadioGroup } from "@fluentui/react-components";
import { clsx } from "clsx/lite";

type PspRadioGroupProps<Options extends readonly KeyLabelPair[]> = {
  options: Options;
  value: Options[number]["key"] | undefined;
  onChange: (value: Options[number]["key"] | undefined) => void;
  label?: string;
  layout?: "horizontal" | "vertical";
  hasBorder?: boolean;
};

export function PspRadioGroup<const Options extends readonly KeyLabelPair[]>({
  options,
  value,
  onChange,
  label,
  layout = "vertical",
  hasBorder,
}: PspRadioGroupProps<Options>) {
  return (
    <div className="flex flex-col gap-1">
      {label && <label className="text-font-secondary">{label}</label>}
      <RadioGroup>
        <div
          className={clsx(
            "flex",
            "w-fit",
            layout === "vertical" ? "flex-col" : "flex-row",
            "gap-2",
          )}
        >
          {options.map((option) => (
            <button
              onClick={() => onChange(option.key)}
              className={clsx(
                "rounded-md",
                "flex-1",
                "tablet:py-0.5",
                "py-1.5",
                "tablet:px-1",
                "text-left",
                "px-1.5",
                "min-w-fit",
                "flex",
                "flex-row",
                "justify-start",
                hasBorder && "border",
                hasBorder && option.key === value
                  ? "border-primary bg-primary-50"
                  : "border-neutral",
              )}
            >
              <Radio
                label={
                  <label className="text-base leading-4">{option.label}</label>
                }
                checked={option.key === value}
                value={option.key}
              />
            </button>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
}
